import React from 'react';
import { motion } from 'framer-motion';
interface HighlightedQuoteProps {
  children: React.ReactNode;
  author?: string;
}
export function HighlightedQuote({
  children,
  author
}: HighlightedQuoteProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.6
  }} className="my-14 md:my-20 relative" data-id="element-3">
      <div className="relative pl-8 md:pl-12 border-l-[6px] border-[#7C9885]" data-id="element-4">
        <div className="text-xl md:text-2xl font-serif italic text-gray-800 leading-relaxed" data-id="element-5">
          {children}
        </div>

        {author && <footer className="mt-6 text-sm font-sans font-medium text-gray-500 tracking-wide" data-id="element-6">
            — {author}
          </footer>}
      </div>
    </motion.div>;
}